import { render, staticRenderFns } from "./_newsId.vue?vue&type=template&id=725d78d1&scoped=true&"
import script from "./_newsId.vue?vue&type=script&lang=js&"
export * from "./_newsId.vue?vue&type=script&lang=js&"
import style0 from "./_newsId.vue?vue&type=style&index=0&id=725d78d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725d78d1",
  null
  
)

export default component.exports